import React, {createContext, ReactNode, useContext, useReducer} from 'react';
import SiteState from './interfaces/SiteState';
import {reducer, initialState} from './reducers/siteReducer';
export {actionTypes as siteActionTypes} from './reducers/siteReducer';

type SiteStateContext = {state: SiteState; dispatch: React.Dispatch<any>};

const SiteStateContext = createContext<SiteStateContext>({} as SiteStateContext);

export default function SiteStateProvider({children}: {children: ReactNode}) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <SiteStateContext.Provider value={{state, dispatch}}>{children}</SiteStateContext.Provider>
  );
}

export const useSiteState = () => {
  const context = useContext(SiteStateContext);
  if (context === undefined) {
    throw new Error('useSiteState must be within SiteStateProvider');
  }

  return context;
};
